// extracted by mini-css-extract-plugin
module.exports = {"blogpost":"blog-post-module--blogpost--2kXvy","blur":"blog-post-module--blur--1JL4S"};